import { Component, OnInit } from '@angular/core';
import { WalkaroundQuestion } from '../../models/walkaround-question.model';
import { WalkaroundQuestionValidatorService } from '../../validators/walkaround-question-validator.service';
import { WalkaroundQuestionService } from '../../services/walkaround-question.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-walkaround-questions-new',
    templateUrl: './walkaround-questions-new.component.html',
    styleUrls: ['./walkaround-questions-new.component.scss'],
    standalone: false
})
export class WalkaroundQuestionsNewComponent implements OnInit {

  question: WalkaroundQuestion = new WalkaroundQuestion();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private questionValidator: WalkaroundQuestionValidatorService,
    private questionService: WalkaroundQuestionService) {
      this.question.vehicleTypeId = 0;
      this.question.active = true;
    }

  ngOnInit(): void {
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if(this.questionValidator.isValid(this.question)) {
      this.questionService.createWalkaroundQuestion(this.question)
      .pipe(take(1))
      .pipe(catchError((e) => {
        if(e.status === 403 || e.status === 401){return e;}
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        window.location.href = '/workshop/walkaround-questions';
      })
    } else {
      this.isError = true;
    }
  }

}
